var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 11.1917C10.3418 11.1917 10.6799 11.1244 10.9954 10.9938C11.3108 10.8631 11.5974 10.6716 11.8389 10.4302C12.0803 10.1887 12.2718 9.90212 12.4025 9.58668C12.5331 9.27123 12.6004 8.93314 12.6004 8.5917C12.6004 8.25026 12.5331 7.91217 12.4025 7.59672C12.2718 7.28128 12.0803 6.99465 11.8389 6.75322C11.5974 6.51179 11.3108 6.32027 10.9954 6.18961C10.6799 6.05895 10.3418 5.9917 10.0004 5.9917C9.31083 5.9917 8.64951 6.26563 8.16191 6.75322C7.67432 7.24082 7.40039 7.90214 7.40039 8.5917C7.40039 9.28126 7.67432 9.94258 8.16191 10.4302C8.64951 10.9178 9.31083 11.1917 10.0004 11.1917Z",
    stroke: "#333335",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01675 7.07496C4.65842 -0.141705 15.3501 -0.133372 16.9834 7.08329C17.9417 11.3166 15.3084 14.9 13.0001 17.1166C12.1935 17.8946 11.1165 18.3293 9.99592 18.3293C8.87529 18.3293 7.79835 17.8946 6.99175 17.1166C4.69175 14.9 2.05842 11.3083 3.01675 7.07496Z",
    stroke: "#333335",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location.0408d4ae.svg";
export { ForwardRef as ReactComponent };